export function Receipt() {
  return (
    <div className="receipt">
      <div className="receipt-head">
        <div className="logo">digis.io</div>
        <div className="sub">CLOSING THE BOOKS - APR 2026</div>
      </div>
      <div className="receipt-row">
        <span>Transactions reconciled</span>
        <span className="check">412 &#10003;</span>
      </div>
      <div className="receipt-row">
        <span>Revolut + EBICS feeds synced</span>
        <span className="check">&#10003;</span>
      </div>
      <div className="receipt-row">
        <span>Stripe payouts matched</span>
        <span className="check">38 &#10003;</span>
      </div>
      <div className="receipt-row">
        <span>Invoices issued</span>
        <span className="check">14 &#10003;</span>
      </div>
      <div className="receipt-row">
        <span>Supplier bills processed</span>
        <span className="check">22 &#10003;</span>
      </div>
      <div className="receipt-row">
        <span>Trial balance closed</span>
        <span className="check">&#10003;</span>
      </div>
      <div className="receipt-row total">
        <span>TIME SAVED</span>
        <span>16h 40m</span>
      </div>
      <div className="receipt-footer">
        - THANK YOU FOR DOING NOTHING -<br />
        &#8251; &#8251; &#8251;
      </div>
    </div>
  );
}
